<template>
  <v-fade-transition mode="out-in">
      <router-view />
  </v-fade-transition>
</template>

<script>
  // Styles
  import '@/styles/overrides.sass'
import { get } from 'vuex-pathify'

  export default {
    name: 'Monpatrol',
    metaInfo: {
      title: 'Monpatrol',
      titleTemplate: '%s',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Monitoring station' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
    computed: {
      ...get('user', [
        'dark'
      ]),
    },
    mounted() {
      // Set the initial dark mode state
      console.log('Dark mode:', this.dark)
      this.$vuetify.theme.dark = this.dark
    },
  }
</script>

<style lang="scss">
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>